if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            // Check if we're on a mobile device
            const isMobile =
              /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
              (navigator.maxTouchPoints && navigator.maxTouchPoints > 1);

            let shareCompleted = false;

            // For desktop, set up visibility change listener to detect return from share
            const handleVisibilityChange = () => {
              if (!shareCompleted && document.visibilityState === 'visible') {
                shareCompleted = true;
                // Wait 10 seconds before showing the modal
                setTimeout(() => {
                  this.showDiscountModal();
                }, 10000);
                document.removeEventListener('visibilitychange', handleVisibilityChange);
              }
            };

            if (!isMobile) {
              // Set up visibility change listener after a small delay
              // to avoid immediate triggering
              setTimeout(() => {
                document.addEventListener('visibilitychange', handleVisibilityChange);
              }, 100);
            }

            navigator
              .share({ url: this.urlToShare, title: document.title })
              .then(() => {
                console.log('Shared successfully');

                if (isMobile) {
                  // On mobile, the promise waits for completion
                  // Wait 10 seconds before showing the modal
                  setTimeout(() => {
                    this.showDiscountModal();
                  }, 10000);
                } else {
                  // On desktop, we rely on the visibility change event
                  // No timeout needed - the visibility API will handle it
                  console.log('Desktop share initiated, waiting for user return...');
                }
              })
              .catch((err) => {
                console.log('Error sharing:', err);
                // Clean up visibility listener on error
                if (!isMobile) {
                  shareCompleted = true;
                  document.removeEventListener('visibilitychange', handleVisibilityChange);
                }
              });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));

          // Add event listener to any share link clicked
          const shareLinks = this.querySelectorAll(
            'a[href*="facebook.com"], a[href*="twitter.com"], a[href*="whatsapp.com"], a[href*="pinterest.com"]'
          );
          shareLinks.forEach((link) => {
            link.addEventListener('click', () => {
              // Wait 10 seconds before showing the modal
              setTimeout(() => {
                this.showDiscountModal();
              }, 10000);
            });
          });
        }
      }

      showDiscountModal() {
        const discountPopup = document.getElementById('discount-popup-modal');
        if (discountPopup) {
          discountPopup.style.display = 'flex';
          document.body.style.overflow = 'hidden';
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();

          // Wait 10 seconds before showing the modal
          setTimeout(() => {
            this.showDiscountModal();
          }, 10000);
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
